import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, isProPlan, $flexRow }) => css`
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-height: 68px;
    padding: ${isProPlan ? '16px 0' : '32px 0 0'};
    width: 100%;

    ${$flexRow && css`
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    `}

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: ${isProPlan ? '4px 20px 0' : '24px 20px 0'};
    }
  `}
`;

export const BottomContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const ChipsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  height: fit-content;
`;

export const HeaderText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const ButtonEditor = styled.button`
  ${({ theme }) => css`
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: ${theme.v2.colors.brand.primaryMedium};
    border-radius: 50%;
    border: none;
    text-align: center;
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};

    svg {
      width: 20px;
      height: 20px;
    }

    &:disabled {
      background: ${theme.v2.colors.feedback.canceledLight};
      cursor: auto;

      svg {
        fill: ${theme.v2.colors.neutral.lowLight};
      }
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 32px;
      height: 32px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  `}
`;
